import React, { Fragment } from "react";
import { Box, Text } from "@chakra-ui/react";

export default function Logo(props) {
  return (
    <Fragment>
      <Box {...props} bg="rgba(255,255,255,0)">
        <Text fontSize="xl" fontWeight="bold" color="teal.500">
          Beaver
        </Text>
      </Box>
    </Fragment>
  );
}
